<div class="row">
	<div class="col-12">
		<div class="content-header"> Project Form</div>
	</div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
	<div class="row">
		<div class="col-12">
			<div class="card">
				<!-- <div class="card-header">
					<h4 class="card-title">Project Form</h4>
				</div> -->
				<div class="card-content">
					<div class="card-body">
						<div class="row">
							<div class="col-md">
                                <form [formGroup]="projectForm">									
									<fieldset class="form-group">
										<label for="name">Name</label>
										<input type="text" class="form-control" formControlName="Pname"
											id="Pname" placeholder="Enter Name" [ngClass]="{ 'is-invalid':
											projectFormSubmitted && rf.Pname.invalid, 'is-valid':
											projectFormSubmitted && !rf.Pname.invalid }"
											required #name>
										<div *ngIf="rf.Pname.touched && (rf.Pname.invalid ||
											rf.Pname.errors?.required)"
											class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> Pname is required
										</div>
									</fieldset>
                                    <fieldset class="form-group" >
										<label for="name">Category</label>
											<select id="tagsId" class="form-control"
											[(ngModel)]="selectedValue" [ngModelOptions]="{standalone: true}"
											(change)="getCategoryId($event)" #category>
											<option value="Select Category" disabled>Select Category </option>
											<option *ngFor="let Category of categories" [value]="Category._id">{{Category.categoryName}}</option>
										</select >
									</fieldset>
                                    <!-- <fieldset class="form-group">
										<label for="fees">fees</label>
										<input type="text" class="form-control" formControlName="fees"
											id="fees" placeholder="Enter fees" [ngClass]="{ 'is-invalid':
											projectFormSubmitted && rf.fees.invalid, 'is-valid':
											projectFormSubmitted && !rf.fees.invalid }"
											required>
										<div *ngIf="projectFormSubmitted && (rf.fees.invalid ||
											rf.fees.errors?.required)"
											class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> fees is required
										</div>
									</fieldset> -->
                                  
                                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                                        <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" [disabled]="(name.value.length === 0 || category.value.length === 0 )" (click)="submitProject()" >Submit</button>
                                        <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                                      </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
